import React from "react";
import RichText from "./RichText";

/**
 * Renders a multi-paragraph body of copy. Splits on blank lines (double newline)
 * and renders each chunk as a <p> with inline markdown (**bold**, *italic*, [link](url))
 * via the safe RichText pipeline.
 *
 * If value is empty or blank, renders nothing.
 * Accepts either a plain string (CMS override) or a React node (code default).
 */
export default function BodyText({ value, className = "prose-qr" }) {
  if (value == null) return null;

  // If the caller passed React (e.g. a JSX fragment default), render as-is.
  if (typeof value !== "string") {
    return <div className={className}>{value}</div>;
  }

  const trimmed = value.trim();
  if (!trimmed) return null;

  const paragraphs = trimmed
    .split(/\n\s*\n/) // blank line separates paragraphs
    .map((s) => s.trim())
    .filter(Boolean);

  return (
    <div className={className}>
      {paragraphs.map((p, i) => (
        <RichText key={i} as="p" value={p} />
      ))}
    </div>
  );
}
